import JSONConfig from './config.json';

const env = process.env.NODE_ENV;

const config = JSONConfig[env]?.hostname ? JSONConfig[env]?.hostname[window.location.hostname] : JSONConfig[env];

export default config;
